import { MaxDirective } from './maxDirective';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  exports: [MaxDirective],
  declarations: [MaxDirective],
  providers: []
})
export class MaxDirectiveModule {}
